import {
  STOCK_MASSIVE_UPLOAD_SET_DROPZONE_STATUS
} from './constants';

export function setMassiveUploadDropzoneStatus({ status, message = null }) {
  return (dispatch) => {
    dispatch({
      type: STOCK_MASSIVE_UPLOAD_SET_DROPZONE_STATUS,
      data: { status, message }
    });
  }
}

export function reducer(state, action) {
  if (action.type === STOCK_MASSIVE_UPLOAD_SET_DROPZONE_STATUS) {
      return {
        ...state,
        massiveUploadDropzoneStatus: action.data.status,
        message: action.data.message
      }
  }
  else {
      return state;
  }
}
